export default {"src":"/_next/static/media/instagram.aac335f7.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};